import FireAnimation from "components/FireAnimation"
import useTranslation from "hooks/useTranslation"
import { useParams } from "react-router-dom"
import { POST } from "api/request"
import { useState } from "react"
import * as url from 'api/urls'
import Modal from "./Modal"

interface CandlesModalProps {
  onClose: () => void
  onAddCandle: (tab: string) => void
  body: board.BoardResponse | null | undefined
  timeLeft?: string
}

const CandlesModal: React.FC<CandlesModalProps> = ({ body, timeLeft, onClose, onAddCandle }) => {
  const { t } = useTranslation('profile')

  const [signature, setSignature] = useState<string>('')
  const [fullListVisible, setFullListVisible] = useState<boolean>(false)
  const [fireAnimation, setFireAnimation] = useState<boolean>(false)
  const params = useParams()

  const lastCandles = body?.data?.lastCandles || []
  const candlesToShow = lastCandles.slice(0, 3)
  const remainingCandlesCount = body?.data ? body.data.candlesAmount - 3 : 0

  const handleSubmit = async () => {
    try {
      const response = await POST(url.addCandle(params['*']), {
        body: { signature }
      })
      if (response.ok) {
        onAddCandle('')
        setFireAnimation(true)
      } else {
        alert('nie dodano - response false')
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <>
      {fullListVisible
        ? <div className="candleFullList">
          <i className="icon icon--close s32" onClick={() => setFullListVisible(false)}></i>
          <p>Brak endpointu do wszystkich zniczy</p>
        </div>
        : fireAnimation
          ? <FireAnimation onClose={onClose} />
          : <Modal
            icon='candle'
            onClose={onClose}
            title={t('light_a_candle')}
            primaryDisabled={timeLeft && body?.data.myCandleExpiration ? true : false}
            primaryButton={timeLeft && body?.data.myCandleExpiration ? t('remaining') + timeLeft : t('light_a_candle')} primaryButtonAction={timeLeft && body?.data.myCandleExpiration ? () => console.log('Musisz poczekać') : handleSubmit}
            secondaryButton={t('cancle')} secondaryButtonAction={'close'}>

            <div className="modal__candle">
              <div className="subtitle">{t('your_candle_will_burn_for_24_hours')}</div>

              <div className="myInput">
                <label>{t('sign_not_required')}</label>
                <input
                  type="text"
                  placeholder={t('exmaple_placeholder')}
                  value={signature}
                  onChange={(e) => setSignature(e.target.value)} />
              </div>

              <p style={{ textAlign: "center" }}>
                {t('by_lighting_a_virtual_candle_you_pay_tribute_to_the_deceased_and_the_person_managing_the_memorial_board_will_receive_a_notification_about_this')}
              </p>

              <div className="candles">
                {candlesToShow.map(candle => (
                  <div key={candle.idx} className="btn btn--round">
                    <i className="icon icon--candle"></i>
                    <span>{candle.signature !== null && candle.signature !== '' ? candle.signature : t('anonymous')}</span>
                  </div>
                ))}
                {remainingCandlesCount > 0 && (
                  <div className="btn btn--round" onClick={() => console.error('brak endpoint')}>
                    <i className="icon icon--candle"></i>
                    +{remainingCandlesCount}
                  </div>
                )}
              </div>
            </div>

          </Modal>}
    </>)
}

export default CandlesModal